module.exports = __webpack_public_path__ + "static/media/CoinMini.614c885a.png";